import { ShieldCheck } from "lucide-react";
import { Link } from "react-router-dom";

export function TermsConsent({ checked, onChange, testId = "terms-consent", className = "" }) {
  return (
    <label className={`flex cursor-pointer items-start gap-3 text-left text-xs leading-relaxed text-soft ${className}`} data-testid={testId}>
      <input type="checkbox" checked={checked} onChange={(e) => onChange(e.target.checked)} className="mt-0.5 h-4 w-4 shrink-0 accent-[#651F38]" data-testid={`${testId}-input`} />
      <span>
        J'accepte les <Link to="/cgv" target="_blank" className="font-medium text-bx underline underline-offset-2">conditions générales de vente</Link>. Je demande l'accès immédiat au parcours et je reconnais renoncer à mon droit de rétractation.
      </span>
    </label>
  );
}

export function Reassurance({ testId, className = "" }) {
  return (
    <p className={`flex flex-wrap items-center justify-center gap-x-1.5 text-center text-xs font-medium text-soft ${className}`} data-testid={testId}>
      <ShieldCheck className="h-3.5 w-3.5 shrink-0 text-gold" strokeWidth={1.8} />
      <span className="whitespace-nowrap">Paiement sécurisé ·</span>
      <span className="whitespace-nowrap">Accès à vie</span>
    </p>
  );
}

const Chip = ({ label, children }) => (
  <span role="img" aria-label={label} title={label}
    className="flex h-7 w-11 items-center justify-center rounded-md border border-line bg-white shadow-[0_1px_2px_rgba(36,33,39,0.06)]">
    {children}
  </span>
);

const Visa = () => (
  <Chip label="Visa">
    <span className="text-[11px] font-black italic tracking-tight text-[#1A1F71]">VISA</span>
  </Chip>
);

const Mastercard = () => (
  <Chip label="Mastercard">
    <svg viewBox="0 0 32 20" className="h-4 w-7" aria-hidden>
      <circle cx="12" cy="10" r="7" fill="#EB001B" />
      <circle cx="20" cy="10" r="7" fill="#F79E1B" />
      <path d="M16 4.3a7 7 0 0 1 0 11.4 7 7 0 0 1 0-11.4z" fill="#FF5F00" />
    </svg>
  </Chip>
);

const Amex = () => (
  <Chip label="American Express">
    <span className="rounded-[3px] bg-[#1F72CD] px-1 py-px text-[8px] font-bold leading-tight tracking-wide text-white">AMEX</span>
  </Chip>
);

const CB = () => (
  <Chip label="Carte Bancaire (CB)">
    <span className="rounded-[3px] bg-[#0D5EA8] px-1.5 py-px text-[9px] font-bold leading-tight text-white">CB</span>
  </Chip>
);

export function CardLogos({ testId = "card-logos", className = "" }) {
  return (
    <div role="group" className={`flex items-center justify-center gap-1.5 ${className}`} data-testid={testId} aria-label="Cartes acceptées : Visa, Mastercard, American Express, CB">
      <Visa />
      <Mastercard />
      <Amex />
      <CB />
    </div>
  );
}
